<template>
  <div class="get-service-wrapper">
    <div class="content-container">
      <h2 class="service-title">
        {{ $t("获取适合您的 Web3 服务") }}
      </h2>

      <p class="service-desc">
        {{ $t("覆盖交易所、钱包、DApp、IM 社交、DeFi 等产品研发服务，为您的项目快速落地。") }}
      </p>

      <div class="tw-flex tw-gap-4 tw-justify-center tw-mt-5">
        <div
          class="service-btn primary-btn tw-flex tw-items-center tw-justify-center tw-cursor-pointer tw-transition-all hover:tw-opacity-90"
          @click="handleConsultClick"
        >
          <span class="btn-text primary-btn-text">{{ $t("在线咨询") }}</span>
        </div>

        <div
          class="service-btn secondary-btn tw-flex tw-items-center tw-justify-center tw-cursor-pointer tw-transition-all hover:tw-opacity-90"
          @click="handleDemoClick"
        >
          <span class="btn-text secondary-btn-text">{{ $t("预约演示") }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GetService',
  methods: {
    handleConsultClick() {
      // 打开客服弹窗
      if (this.$screen.md) {
        window.kuaizhichat();
      } else {
        window.kuaizhiMobileChat();
      }
    },
    handleDemoClick() {
      // 跳转到联系我们页面或打开表单
      this.$router.push('/contact');
    }
  }
};
</script>

<style scoped lang="scss">
.get-service-wrapper {
  width: 100%;
  background: url('~@/assets/home/getServer.png') no-repeat center center;
  background-size: cover;
  background-position: center;
  padding: 50px 20px;
}

.content-container {
  max-width: 800px;
  margin: 0 auto;
}

.service-title {
  font-weight: 600;
  font-size: 24px;
  color: #111111;
  text-align: center;
  margin-bottom: 20px;
}

.service-desc {
  font-weight: 400;
  font-size: 16px;
  color: #666666;
  text-align: center;
  margin-top: 20px;
}

.service-btn {
  width: 124px;
  height: 48px;
  border-radius: 8px;
}

.primary-btn {
  background: linear-gradient(90deg, #4077F8 0%, #3D4BDF 100%);
}

.secondary-btn {
  background: rgba(255,255,255,0.3);
  border: 1px solid #4077F8;
}

.btn-text {
  font-weight: 500;
  font-size: 16px;
}

.primary-btn-text {
  color: #FFFFFF;
}

.secondary-btn-text {
  color: #4077F8;
}

@media (max-width: 767px) {
  .service-title {
    font-weight: 600;
    font-size: 20px;
    color: #111111;
    line-height: 28px;
  }

  .service-desc {
    font-weight: 600;
    font-size: 12px;
    color: #666666;
    line-height: 16px;
  }

  .service-btn {
    border-radius: 100px;
  }

  .btn-text {
    font-weight: 500;
    font-size: 14px;
  }
}
</style>
